module.exports = __webpack_public_path__ + "static/forbes-logo-d3b6ded676cd52bf0e5506ef3f621183.png";